<wuc-button type="clean" e2e="modal_close" modal-close-btn>
    <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>

<h2 modal-title>Hoe werkt bonus-malus?</h2>
<div modal-content>
    <p>
        Bonus-malus betekent letterlijk beloning-straf. Hoe meer schadevrije jaren u hebt, hoe hoger u staat op de
        bonus-malusladder. Elk jaar dat u geen schade claimt, gaat u weer een treetje omhoog. Een treetje hoger,
        betekent minder premie (beloning). Claimt u wel schade? Dan gaat u een paar tredes omlaag en gaat uw premie dus
        wat omhoog (straf).
    </p>
    <wuc-accordion>
        <wuc-accordion-item>
            <span slot="title">Bonus voor schadevrije rijders</span>
            <p>
                Als u geen schade claimt bij uw {{ productName }}, bouwt u schadevrije jaren op. Aan de hand van het
                aantal
                <wuc-link url="/{{ productName }}/schadevrije-jaren-{{ productName }}">schadevrije jaren</wuc-link>
                wordt u beloond door uw verzekeraar met korting op de premie, een bonus dus.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Malus voor brokkenpiloten</span>
            <p>
                De andere kant van de medaille heet malus. Als u schade heeft en deze claimt bij uw verzekeraar,
                daalt u op de bonus-malus ladder. U wordt dan ‘gestraft’ voor het claimen van schade en uw premie
                gaat omhoog.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">De bonus-malus ladder</span>
            <p>
                De meeste {{ productNameShort }}verzekeraars werken met een bonus-malus ladder die vaak uit 15 tot
                20 treden bestaat. Hoe hoger u op de ladder staat, hoe hoger uw korting op de
                <wuc-link url="/{{ productName }}">{{ productName }}</wuc-link>
                . Elk jaar dat u geen schade claimt, gaat u een trede omhoog op de ladder en bent u het jaar daarop
                goedkoper uit. Claimt u wel schade, dan gaat u vaak meerdere treden omlaag en stijgt uw premie weer.
                Het aantal treden dat u zakt verschilt per verzekeraar.
            </p>
            <p>
                Het kan dus slim zijn om uit te rekenen wat meer kost: de reparatie van de schade of het verschil in
                verzekeringspremie. Als de reparatie uiteindelijk goedkoper is, kunt u ervoor kiezen om de schade
                zelf te laten repareren.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Verschillen per verzekeraar</span>
            <div content>
                <p>
                    Iedere {{ productNameShort }}verzekeraar heeft zijn eigen bonus-malus ladder. De maximale korting,
                    de maximale toeslag, het aantal treden en het aantal treden dat u terugvalt als u een schade claimt
                    kunnen verschillen. Hoe voordelig een {{ productName }} is, hangt bij de meeste
                    {{ productNameShort }}verzekeraars dus niet alleen af van de basispremie.
                </p>
            </div>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Bonus-malus bij InShared</span>
            <p>
                Bonus-malus betekent letterlijk beloning-straf. Hoe meer schadevrije jaren u hebt, hoe hoger u staat
                op de bonus-malusladder. Elk jaar dat u geen schade claimt, gaat u weer een treetje omhoog. Een
                treetje hoger, betekent minder premie en dat is dus het beloningsgedeelte. Claimt u wel schade? U
                raadt het al: dan gaat u een paar tredes omlaag op de ladder. En gaat uw premie dus wat omhoog. U
                leest daar alles over in
                <wuc-link [url]="documentsEnum.BonusMalusTableCarInsurance" target="_blank">deze tabel</wuc-link>
                .
            </p>
            <p>
                <ng-container *ngIf="productId === productIdEnum.Car">
                    <wuc-link [url]="documentsEnum.BonusMalusStepCarInsurance" target="_blank">
                        Kijk meteen op welke tree u staat!
                    </wuc-link>
                </ng-container>
                <ng-container *ngIf="productId === productIdEnum.Motorcycle">
                    <wuc-link [url]="documentsEnum.BonusMalusStepMotorInsurance" target="_blank">
                        Kijk meteen op welke tree u staat!
                    </wuc-link>
                </ng-container>
                <ng-container *ngIf="productId === productIdEnum.Moped">
                    <wuc-link [url]="documentsEnum.BonusMalusStepMopedInsurance" target="_blank">
                        Kijk meteen op welke tree u staat!
                    </wuc-link>
                </ng-container>
            </p>
        </wuc-accordion-item>
    </wuc-accordion>
</div>
